import React from "react";
import { MapPin } from "lucide-react";
import { branches } from "../mock";

const Locations = () => {
  return (
    <section className="icg-section bg-[color:var(--icg-cream-soft)]">
      <div className="icg-container">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div>
            <span className="icg-eyebrow"><span className="icg-dot" /> Our branches</span>
            <h2 className="font-display font-semibold tracking-tight mt-5"
                style={{ fontSize: "clamp(32px, 4.5vw, 56px)", lineHeight: 1.02 }}>
              We work for you
              <br />
              <span className="font-serif-it text-[color:var(--icg-accent)]">across time zones</span>.
            </h2>
          </div>
          <p className="max-w-sm text-[color:var(--icg-muted)] leading-relaxed">
            Three offices, one shared standard for craft, communication and follow-through.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {branches.map((b) => (
            <div
              key={b.city}
              className="icg-lift bg-[color:var(--icg-cream)] border border-[color:var(--icg-line)] rounded-2xl p-8"
            >
              <div className="flex items-center gap-2 text-[color:var(--icg-accent)]">
                <MapPin size={16} />
                <span className="text-xs uppercase tracking-widest text-[color:var(--icg-muted)]">
                  {b.role}
                </span>
              </div>
              <div className="mt-6 font-display font-semibold tracking-tight text-4xl">
                {b.city}
              </div>
              <div className="mt-3 text-[color:var(--icg-muted)] leading-relaxed">{b.address}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;
